const palette = [
  { name: 'color1', value: '#343FBA' },
  { name: 'color2', value: '#3171E4' },
  { name: 'color3', value: '#9FCECD' },
  { name: 'color4', value: '#FBEBA3' },
  { name: 'color5', value: '#5CAAE4' },
  { name: 'color6', value: '#69B45E' },
  { name: 'color7', value: '#9CD993' },
  { name: 'color8', value: '#BFBFBF' },
];

const generatePieColors = palleteLength => (
  palette.slice(0, palleteLength)
);

export default generatePieColors;
